import * as React from 'react';
import { LinkButton, UIHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './ChoicePopup.css';

export interface IChoicePopupProps extends React.PropsWithChildren {
  description: string;
  icon: React.ReactNode;
  title: string;
  url: string;
}

export const ChoicePopUp: React.FC<IChoicePopupProps> = ({ children, description, icon, title, url }) => {
  return (
    <span className={styles['container']}>
      <a className={styles['content']} href={url} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
      <div className={styles['tooltip']}>
        {icon}
        <UIHeading4 as="h3">{title}</UIHeading4>
        <div className={styles['description']}>
          <UIText2 as="p">{description}</UIText2>
        </div>
        <div className={styles['show-more']}>
          <LinkButton href={url} target="_blank" rel="noopener noreferrer" theme="fill_secondary" size="XS">
            Узнать подробнее
          </LinkButton>
        </div>
      </div>
    </span>
  );
};
